<script lang="ts">
  import { onMount } from 'svelte';
  import { M2 } from '../modules';

  let currentQuality: string = 'normal';
  const options = [
    { value: 'data-saver', label: 'Data Saver' },
    { value: 'normal', label: 'Normal' },
    { value: 'high', label: 'High Quality' },
  ];

  let isStorageAvail: boolean = true;

  onMount(() => {
    currentQuality = M2?.getQualityPreference?.() ?? 'normal';
    isStorageAvail = M2?.isPersistent?.() !== false;
  });

  function selectQuality(value: string) {
    M2?.setQualityPreference?.(value);
    currentQuality = value;
  }
</script>

{#if !isStorageAvail}
  <p class="settings-notice">Browser storage unavailable — stations won't be saved</p>
{/if}

<div class="sq-box">
  <span class="sq-label">Audio Quality</span>
  <div class="sq-opt-container" role="radiogroup" aria-label="Audio quality" tabindex="0">
    {#each options as opt}
      <span
        class="sq-opt"
        class:sq-opt--selected={currentQuality === opt.value}
        role="radio"
        aria-checked={currentQuality === opt.value}
        tabindex={currentQuality === opt.value ? 0 : -1}
        on:click={() => selectQuality(opt.value)}
        on:keydown={(e) => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectQuality(opt.value); } }}>
        {currentQuality === opt.value ? '[X] ' : '[ ] '}{opt.label}
      </span>
    {/each}
  </div>
</div>
